export default __webpack_public_path__ + "static/media/006.5abed314.jpg";